// EmptyState — shared empty / zero-results layout per spec §18.4.

import type { LucideIcon } from 'lucide-react';

interface EmptyStateProps {
  icon?: LucideIcon;
  title: string;
  body: string;
  ctaLabel?: string;
  onCta?: () => void;
}

export function EmptyState({ icon: Icon, title, body, ctaLabel, onCta }: EmptyStateProps) {
  return (
    <div className="empty-state">
      {Icon && (
        <div className="empty-state__icon" aria-hidden="true">
          <Icon size={28} strokeWidth={1.6} />
        </div>
      )}
      <h3 className="empty-state__title">{title}</h3>
      <p className="empty-state__body">{body}</p>
      {ctaLabel && onCta && (
        <button type="button" className="btn btn--hero" onClick={onCta}>
          {ctaLabel}
        </button>
      )}
    </div>
  );
}
